module.exports = __webpack_public_path__ + "img/notifications-new.377bbe31.svg";